import { fetchRetry } from "utils/fetch";

export class TeaserClient {
	async get(url: string): Promise<string> {
		try {
			const response = await fetchRetry({
				url,
				namespace: "cinema-teaser",
				fetchOptions: {
					headers: {
						Accept: "text/html;charset=UTF-8",
						"X-Requested-With": "XMLHttpRequest",
					},
					priority: "high",
				},
				retryOptions: {
					limit: 2,
					delay: 50,
				},
			});

			const responseText = await response.text();
			if (response.status === 200 || response.status === 204) {
				return responseText;
			}

			/*                                    */
			throw Error(`${responseText}`);
		} catch (error: unknown) {
			if (error instanceof Error) {
				throw Error(`could not retrieve partner benefit teaser '${error.message}'`);
			}
			if (typeof error === "string") {
				throw Error(`could not retrieve partner benefit teaser '${error}'`);
			}
			throw error;
		}
	}
}
